const createProductLookup = (productProjections) => {
  let product = {};
  let variant = {};
  productProjections.forEach((p) => {
    const variants = [p.masterVariant, ...p.variants];
    variants.forEach((v) => {
      if (v.sku) {
        product = { ...product, [v.sku]: p };
        variant = { ...variant, [v.sku]: v };
      }
    });
  });
  return {
    product,
    variant
  };
};
export {
  createProductLookup
};
//# sourceMappingURL=create-product-lookup.js.map
